// tslint:disable: trailing-comma
import { IShipmentLocation } from './shipment-location';

export interface IShipmentLocationResponse {
  links: {
    self: string
  };
  shipmentLocations: IShipmentLocation[];
  count: number;
}
